import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ApplicationError } from '../common/error.model';
import { ForgotPasswordRequestVO } from './forgotpassword.model';
import { ForgotPasswordService } from './forgotpassword.service';
import { environment } from "../../environments/environment"

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  emailId: string;
  resetToken: string;
  resetPasswordForm: FormGroup;
  statusMsg: string;
  loginUrl: string;
  
  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private forgotPasswordService: ForgotPasswordService) { }

  ngOnInit() {
    this.resetPasswordForm = this.formBuilder.group({
      newPassword: [null, Validators.required],
      confirmPassword: [null, [Validators.required]]
    });
    
    this.route.queryParams.forEach((params: Params) => {
      this.emailId = params['email'];
      this.resetToken = params['token'];
    }); 
  } 

  submitForm(form: any): void {
    let forgotPasswordRequestVO = new ForgotPasswordRequestVO();
    forgotPasswordRequestVO.setEmailId(this.emailId);
    forgotPasswordRequestVO.setResetToken(this.resetToken);
    forgotPasswordRequestVO.setNewPassword(this.resetPasswordForm.value.newPassword);
    forgotPasswordRequestVO.setConfirmPassword(this.resetPasswordForm.value.confirmPassword);
    this.resetPasswordForm.reset();
    this.forgotPasswordService.updatePassword(forgotPasswordRequestVO).then(
      response => {
        this.statusMsg = `Password successfully changed`;
        this.loginUrl = environment.DASHBOARD_URL;
      },
      errorResponse => {
        this.statusMsg = "Unknown Error";
        this.loginUrl = null;
        if(errorResponse instanceof ApplicationError){
          this.statusMsg = errorResponse.statusMsg;
        };
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.component.ts